import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import { GetPropertyScoreActionsResponseTO } from 'models/bookingDotCom/PropertyScore';
import API from 'services/API';

export const PROPERTY_SCORE_ACTIONS_BASE_QUERY_KEY =
  'booking-dot-com-score-actions';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetPropertyScoreActionsResponseTO>,
  'queryKey' | 'queryFn'
>;

type UseFetchBookingDotComPropertyScoreActionsArgs = {
  propertyUid: string;
} & ReactQueryOptions;

const useFetchBookingDotComPropertyScoreActions = ({
  propertyUid,
  enabled = true,
  ...options
}: UseFetchBookingDotComPropertyScoreActionsArgs) => {
  return useAppQuery<GetPropertyScoreActionsResponseTO>({
    queryKey: [PROPERTY_SCORE_ACTIONS_BASE_QUERY_KEY, 'detail', propertyUid],
    queryFn: async () => {
      const response = await API.get<GetPropertyScoreActionsResponseTO>(
        '/api/internal/bookingdotcom/properties/property-score-actions',
        { params: { resourceUid: propertyUid } },
      );

      return response.data;
    },
    enabled,
    cacheTime: 5 * 60 * 1000,
    staleTime: 30000,
    ...options,
  });
};

export default useFetchBookingDotComPropertyScoreActions;
